import * as React from 'react';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useIntl } from 'react-intl';

const toggleGroupStyles = {
  borderRadius: 1,
  '& .MuiToggleButtonGroup-grouped': {
    height: '38px',
    px: 1.5,
  },
  '& .MuiToggleButtonGroup-grouped > svg': {
    fontSize: '1.25rem',
  },
};

const ViewModeToggle = ({ setFindListMode, findListMode }) => {
  const intl = useIntl();
  const handleToggleMode = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    setFindListMode(newAlignment);
  };

  return (
    <ToggleButtonGroup
      sx={toggleGroupStyles}
      size="small"
      value={findListMode}
      exclusive
      onChange={handleToggleMode}
      aria-label={intl.formatMessage({
        id: 'finds.viewMode.label',
        defaultMessage: 'Find list mode',
      })}
    >
      <ToggleButton
        value="grid"
        aria-label={intl.formatMessage({
          id: 'finds.viewMode.grid',
          defaultMessage: 'Table',
        })}
      >
        <ViewListIcon />
      </ToggleButton>
      <ToggleButton
        value="gallery"
        aria-label={intl.formatMessage({
          id: 'finds.viewMode.gallery',
          defaultMessage: 'Gallery',
        })}
      >
        <ViewModuleIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export { ViewModeToggle };
